module.exports = __webpack_public_path__ + "img/bg-ppt-3.833cdc44.png";